import React from 'react'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import { formatDateLabel, sanitizeNotification, truncateText } from '../../lib/utils'

const typeStyles = {
  SUCCESS: 'notification-pill-success',
  ERROR: 'notification-pill-error',
  WARNING: 'notification-pill-warning',
  INFO: 'notification-pill-info',
}

const typeIcons = {
  SUCCESS: 'check-circle',
  ERROR: 'times-circle',
  WARNING: 'exclamation-circle',
  INFO: 'info-circle',
}

const MAX_LENGTH = 220

export default class NotificationListItem extends React.Component {

  state = {
    expanded: false,
  }

  toggleExpanded = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }))
  }

  render() {

    const { notification, selected, onToggleSelect, onMarkRead, onDelete, running, } = this.props,
    { expanded } = this.state,
    cleanedText = sanitizeNotification(notification.content),
    showReadMore = cleanedText && cleanedText.length > MAX_LENGTH

    return (
      <div className={`notification-item ${ notification.read ? 'notification-item-read' : 'notification-item-unread' }`}>
        <div className="notification-select-wrap">
          <input
            type="checkbox"
            checked={ selected }
            onChange={() => onToggleSelect(notification.id)}
            aria-label={`Select ${ notification.title }`}
          />
        </div>

        <div className="notification-item-main">
          <div className="notification-item-header">
            <span className={ `notification-type ${ typeStyles[notification.type] || typeStyles.INFO }` }>
              <FontAwesome name={ typeIcons[notification.type] || typeIcons.INFO } />
              { notification.type }
            </span>

            { !notification.read && <span className="notification-unread-dot" title="Unread" /> }
          </div>

          <h3 className="notification-item-title">{ notification.title }</h3>

          { cleanedText && (
            <div className="mb-10">
              <div
                className="notification-item-content"
                dangerouslySetInnerHTML={{ __html: expanded ? cleanedText : truncateText(cleanedText, MAX_LENGTH) }}
              />

              { showReadMore && (
                <button type="button" className="notification-read-more" onClick={ this.toggleExpanded }>
                  { expanded ? 'Show less' : 'Read more' }
                </button>
              )}
            </div>
          )}

          <div className="notification-item-meta">
            <span title={ notification.createdOn ? new Date(notification.createdOn).toLocaleString() : '' }>
              { notification.createdOn ? formatDateLabel(new Date(notification.createdOn.toLocaleString())) : '' }
            </span>

            <div className="notification-item-actions">

              {!notification.read && (
                <button
                  type="button"
                  className="notification-action-btn notification-action-mark"
                  onClick={() => onMarkRead(notification.id)}
                  disabled={ running }
                >
                  Mark as read
                </button>
              )}

              <button
                type="button"
                className="notification-delete-btn"
                onClick={() => onDelete(notification.id)}
                disabled={ running }
                aria-label={`Delete ${ notification.title }`}
              >
                <FontAwesome name="trash" /> Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NotificationListItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    read: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['SUCCESS', 'ERROR', 'WARNING', 'INFO']).isRequired,
    createdOn: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool,
  onToggleSelect: PropTypes.func.isRequired,
  onMarkRead: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  running: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationListItem.js